import React from 'react';
import { Admin } from '../../components/Admin';

interface AdminPageProps {
  defaultTab?: 'agents' | 'users' | 'documents' | 'knowledgeGraph' | 'models';
}

const AdminPage: React.FC<AdminPageProps> = ({ defaultTab }) => {
  return <Admin defaultTab={defaultTab} />;
};

export default AdminPage;
